module.exports = __webpack_public_path__ + "static/app-flow2-9f2727baae686ade57f6a198f09df25e.png";